__webpack_require__.p = "https://portal.inserv.msk.ru/";